import { render } from "./SPManagement.vue?vue&type=template&id=1b3a1025&scoped=true"
import script from "./SPManagement.vue?vue&type=script&lang=js"
export * from "./SPManagement.vue?vue&type=script&lang=js"

import "./SPManagement.vue?vue&type=style&index=0&id=1b3a1025&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3a1025"]])

export default __exports__